import { util } from '../util/axiosConf';
import { activeLicense } from './configActiveLicense';

export default {
  selAuthorizePage() {
    return util.get(`${activeLicense.selAuthorizePage}`);
  },
  createProcessId() {
    return util.get(`${activeLicense.createProcessId}`);
  },
  saveAuthorizeInfo(param) {
    return util.post(`${activeLicense.saveAuthorizeInfo}?processId=${param.processId}`, { licenseKeyList: param.licenseKeyList, step: param.step, cacheKey: param.cacheKey});
  },
  // 校验设备是否弹窗
  checkDeviceInfo(data) {
    return util.post(`${activeLicense.checkDeviceInfo}`, data);
  },
  // 查询自定义设备标识信息列表
  getCustomizeDeviceInfo(data) {
    return util.post(`${activeLicense.getCustomizeDeviceInfo}`, data);
  },
  // 通过自定义设备标识信息查询文件
  // getCustomizeDeviceInfo(params) {
  //   return util.get(`${activeLicense.getCustomizeDeviceFile}`, params);
  // },
  // (批量)录入设备信息
  inputDeviceInfo(data) {
    return util.post(`${activeLicense.inputDeviceInfo}`, data);
  },
  removeAuthorizeInfos(param) {
    // return util.post(`${activeLicense.removeAuthorizeInfos}?processId=${param.processId}&ids=${param.ids}`);
    return util.post(`${activeLicense.removeAuthorizeInfos}`, param);
  },
  downloadLicenseKeyTemplate(param) {
    return util.get(`${activeLicense.downloadLicenseKeyTemplate}`);
  },
  getAuthorizeListByFile(param) {
    return util.post(`${activeLicense.getAuthorizeListByFile}?processId=${param.processId}`, param.file, {noTip: true});
  },
  saveAuthorizeInfoBatch(param) {
    return util.post(`${activeLicense.saveAuthorizeInfoBatch}?processId=${param.processId}`, param.list, {noTip: true});
  },
  step(param) {
    return util.post(`${activeLicense.step}`, param);
  },
  parseQrCode(param) {
    return util.post(`${activeLicense.parseQrCode}`, param);
  },
  captcha: () => {
    return util.get(activeLicense.captcha);
  },
  saveUserInfo(param) {
    return util.post(`${activeLicense.saveUserInfo}`, param);
  },
  verification(param) {
    // return http.get(`${activeLicense.verification}?`+ qs.stringify(params), params)
    return util.get(`${activeLicense.verification}?verifyKey=${param.verifyKey}&verifyCode=${param.verifyCode}`, param);
  },
  inputDeviceInfo(data) {
    return util.post(`${activeLicense.inputDeviceInfo}`,data);
  },
  // 上传设备信息文件
  uploadDeviceFile(data){
    return util.post(`${activeLicense.uploadDeviceFile}?licenseKey=${data.licenseKey}&id=${data.id}&isMaster=${data.isMaster}&deviceUnit=${data.deviceUnit}&cacheKey=${data.cacheKey}`,data.file);
  },
  // 上传历史信息文件
  uploadOldActivationFile(data){
    return util.post(`${activeLicense.uploadOldActivationFile}?licenseKey=${data.licenseKey}&id=${data.id}&isMaster=${data.isMaster}&deviceUnit=${data.deviceUnit}&cacheKey=${data.cacheKey}&processId=${data.processId}`,data.file);
  },
  // 复制文件
  copyDeviceFile(data){
    return util.post(`${activeLicense.copyDeviceFile}`,data);
  },
  // 重置
  resetApi(data) {
    return util.post(`${activeLicense.resetApi}`,data);
  },
  // 取消
  cancelDeviceFile(data) {
    return util.post(`${activeLicense.cancelDeviceFile}`,data);
  },
  submitActivation(param) {
    return util.post(`${activeLicense.submitActivation}`, param);
  },
  stepValidate(param) {
    return util.post(`${activeLicense.stepValidate}`, param);
  },
  fileDownloadBatch(param) {
    return util.get(`${activeLicense.fileDownloadBatch}?activeId=${param.activeId}&cacheKey=${param.cacheKey}`);
  },
  getUserInfo(param) {
    return util.get(`${activeLicense.getUserInfo}?processId=${param.processId}`);
  },
  downloadActivationFile(param) {
    return util.get(`${activeLicense.downloadActivationFile}?activeId=${param.activeId}&cacheKey=${param.cacheKey}`);
  },
  selAuthorizeList(data) {
    return util.post(`${activeLicense.selAuthorizeList}`, data);
  },
};
